import { ReactElement, ReactNode } from "react";

export default function FormInputWrapper(props: {
  children: ReactNode;
}): ReactElement {
  return <div className="grid my-2">{props.children}</div>;
}
